import React from "react";
import "./Gallery.css";

// Automatically import all images from gallery folder
const images = require
  .context("../assets/gallery", false, /\.(png|jpe?g|svg)$/)
  .keys()
  .map(
    require.context("../assets/gallery", false, /\.(png|jpe?g|svg)$/)
  );

function Gallery() {
  return (
    <div className="page">
      <h1 className="page-title">Gallery</h1>

      <div className="gallery-grid">
        {images.map((img, index) => (
          <div className="gallery-card" key={index}>
            <img
              src={img}
              alt={`Gallery ${index}`}
              className="gallery-image"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Gallery;



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import API_BASE_URL from "../config/api";
// import "./Gallery.css";

// function Gallery() {
//   const [images, setImages] = useState([]);

//   const loadImages = async () => {
//     try {
//       const res = await axios.get(`${API_BASE_URL}/gallery/files`);
//       setImages(res.data);
//     } catch (err) {
//       console.error("Failed to load images", err);
//     }
//   };

//   useEffect(() => {
//     loadImages();
//   }, []);

//   return (
//     <div className="page">
//       <h1 className="page-title">Gallery</h1>

//       <div className="gallery-grid">
//         {images.map((img, index) => (
//           <div className="gallery-card" key={index}>
//             <img
//               src={`/uploads/gallery/${img}`}
//               alt="Gallery"
//               style={{ width: "100%", height: "200px", objectFit: "cover" }}
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Gallery;
